import { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import { cx } from "../StudioShared";
import { NODE_META, BRANCHING, NO_TARGET, NO_SOURCE, REPLAY_RING } from "./nodeMeta";

function AiposNodeBase({ id, type, data, selected }) {
  const meta = NODE_META[type] || NODE_META.ai_strategist;
  const Icon = meta.icon;
  const replay = data?.replay;
  const cfg = data?.config || {};
  const subtitle =
    type === "input" || type === "variable" ? cfg.key || cfg.default :
    type === "ai_strategist" ? cfg.strategist_name || cfg.strategist_id :
    type === "department" ? cfg.department :
    type === "condition" ? `${cfg.variable || "?"} ${cfg.operator || "equals"} ${cfg.value ?? ""}` :
    type === "delay" ? cfg.mode :
    type === "export" ? cfg.format : "";

  return (
    <div
      data-testid={`wf-node-${id}`}
      className={cx(
        "min-w-[168px] max-w-[210px] rounded-md border bg-[#0A1128] px-3 py-2.5 transition-all",
        meta.accent,
        selected ? "ring-2 ring-white/40" : "",
        replay ? REPLAY_RING[replay] : "",
      )}
    >
      {!NO_TARGET.has(type) && (
        <Handle type="target" position={Position.Left} className="!bg-white/60 !w-2 !h-2" />
      )}
      <div className="flex items-center gap-2">
        <span className={cx("w-6 h-6 flex items-center justify-center rounded-sm border", meta.accent)}>
          <Icon size={13} />
        </span>
        <div className="min-w-0">
          <div className="text-white text-[13px] font-medium leading-tight truncate">{data?.label || meta.label}</div>
          <div className="text-[10px] uppercase tracking-wider text-slate-500 truncate">{meta.label}</div>
        </div>
      </div>
      {subtitle ? <div className="mt-1.5 text-[11px] text-slate-400 truncate">{String(subtitle)}</div> : null}

      {NO_SOURCE.has(type) ? null : BRANCHING.has(type) ? (
        <>
          <Handle id="true" type="source" position={Position.Right} style={{ top: "35%" }} className="!bg-emerald-400 !w-2.5 !h-2.5" />
          <Handle id="false" type="source" position={Position.Right} style={{ top: "70%" }} className="!bg-red-400 !w-2.5 !h-2.5" />
          <span className="absolute right-1 top-[26%] text-[8px] text-emerald-300">T</span>
          <span className="absolute right-1 top-[61%] text-[8px] text-red-300">F</span>
        </>
      ) : (
        <Handle type="source" position={Position.Right} className="!bg-white/60 !w-2 !h-2" />
      )}
    </div>
  );
}

export const AiposNode = memo(AiposNodeBase);
